import { render } from "./PropertyData.vue?vue&type=template&id=7256cc52"
import script from "./PropertyData.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyData.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/facility/PropertyData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7256cc52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7256cc52', __exports__)) {
    console.log('reload')
    api.reload('7256cc52', __exports__)
  }
  
  module.hot.accept("./PropertyData.vue?vue&type=template&id=7256cc52", () => {
    console.log('re-render')
    api.rerender('7256cc52', render)
  })

}


export default __exports__